// extracted by mini-css-extract-plugin
module.exports = {"component":"TireSearch_component__wM9bD","searchInput":"TireSearch_searchInput__D3dVw"};